import { formatWind, type Observation } from '@skyweather/weather-core'
import { windUnit } from './format.js'
import { gustOpacity, minsSecsAgo, recentPeakGusts } from './gusts.js'
import type { SiteUnits } from './types.js'

/** The list looks back two hours, though the trend it is given reaches back further (the chart's 6 hours). */
export const RECENT_GUSTS_WINDOW_MS = 2 * 60 * 60_000

interface Props {
  /** The shown feed's recent readings (the trend window), any order. */
  readings: Observation[]
  units: SiteUnits
  now: number
}

/**
 * The five most recent significant gusts, newest first, each fainter than the one before, in one row so
 * the wind panel keeps its height for the windsock. The times tick every second, in minutes:seconds ago.
 */
export function RecentGusts({ readings, units, now }: Props) {
  const peaks = recentPeakGusts(readings.filter((o) => o.observedAt >= now - RECENT_GUSTS_WINDOW_MS))
  const unit = windUnit(units)
  return (
    <section className="gusts" aria-label="Recent peak gusts">
      <h3 className="gusts__title">Recent peak gusts</h3>
      {peaks.length === 0 ? (
        <p className="gusts__none">No significant gusts in the last two hours.</p>
      ) : (
        <ol className="gusts__list">
          {peaks.map((p, i) => (
            <li key={p.at} className="gusts__item" style={{ opacity: gustOpacity(i) }}>
              <span className="gusts__value">{formatWind(p.gustKt, unit, { withKnots: false, role: 'gust' })}</span>
              <span className="gusts__ago">{minsSecsAgo(p.at, now)}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
